import { render, staticRenderFns } from "./Sucursales.vue?vue&type=template&id=8c83afb4"
import script from "./Sucursales.vue?vue&type=script&lang=js"
export * from "./Sucursales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports